import React from 'react';

/**
 * App-styled confirmation dialog (replaces window.confirm).
 */
export default function ConfirmModal({
  title = 'Confirm',
  message,
  confirmLabel = 'OK',
  cancelLabel = 'Cancel',
  variant = 'danger',
  loading = false,
  onConfirm,
  onCancel,
}) {
  const confirmClass = variant === 'danger' ? 'btn btn-red' : 'btn btn-blue';

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && !loading && onCancel()}>
      <div className="modal confirm-modal" style={{ width: 420 }}>
        <button type="button" className="modal-close" onClick={onCancel} disabled={loading} aria-label="Close">
          &times;
        </button>
        <h2>{title}</h2>
        <p className="confirm-modal-message">{message}</p>
        <div className="confirm-modal-actions">
          <button type="button" className="btn btn-gray" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button type="button" className={confirmClass} onClick={onConfirm} disabled={loading}>
            {loading ? 'Please wait...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
